module.exports = __webpack_public_path__ + "img/podium_2022.e33796ec.jpg";